import { AdminChromePageTitleBar } from '@/Client/Layout/AdminChromePageTitleBar';
import { useCurrentOrg } from '@kaiizen/kai-pro-api-react-state';
import { ReactNode } from 'react';
import { NotificationBell } from '../Widgets/NotificationBell';
import { ProfileDropdownMenu } from '../Widgets/ProfileDropdownMenu';
import { SyncingStatusIndicator } from '../Widgets/SyncingStatusIndicator';

export const PageTitleBar = ({
  title,
  titleIcons,
  headerButtons,
  orgPrefix,
  onBack,
}: {
  title: string;
  titleIcons?: ReactNode[];
  headerButtons?: ReactNode;
  orgPrefix?: ReactNode;
  onBack?: () => void;
}) => {
  const { currentOrg } = useCurrentOrg();
  return (
    <AdminChromePageTitleBar
      title={title}
      titleIcons={titleIcons}
      headerButtons={headerButtons}
      onBack={onBack}
      orgLabel={orgPrefix
        ? (
          <span>
            {orgPrefix}
            {currentOrg?.name ? <span>{currentOrg.name}</span> : null}
          </span>
        )
        : (
          currentOrg?.name || ''
        )}
      notifications={<NotificationBell />}
      syncStatus={<SyncingStatusIndicator />}
      profile={<ProfileDropdownMenu />}
    />
  );
};
